import React from 'react'
import ProductTile from './ProductTile'
import withItemTileHover from '../../itemTile/withItemTileHover'

const HoveredProductTile = props => {
  let HoveredProductTile = withItemTileHover(ProductTile, true, 44)
  return <HoveredProductTile {...props} />
}

export default HoveredProductTile
